import React from "react";
import "./About.css";
import NewsletterSignup from "./newsletter/NewsletterSignup";

function About() {
  return (
    <div className="about_page">
      <div className="about_container">
        <h1 className="about_heading">The Futsal Directory</h1>
        <p className="about_text">
          The Futsal Directory aims to promote the sport of Futsal by providing
          updated information related to local venues that can be hired to play
          the game we all love.
        </p>
        <div className="about_newsletter">
          <NewsletterSignup></NewsletterSignup>
        </div>

        <h2>Contact</h2>
      <p>For all enquiries please email: </p>
      <a href="mailto:thefutsaldirectory@gmail.com">
        thefutsaldirectory@gmail.com
      </a>
      </div>
    </div>
  );
}

export default About;
